export default [
  new Date(),

  //ENERO 2022
  new Date(2022, 0, 1),
  new Date(2022, 0, 2),
  new Date(2022, 0, 8),
  new Date(2022, 0, 9),
  new Date(2021, 0, 15),
  new Date(2021, 0, 16),
  new Date(2021, 0, 22),
  new Date(2021, 0, 23),
  new Date(2021, 0, 29),
  new Date(2021, 0, 30),

  //Febrero 2022
  new Date(2022, 1, 5),
  new Date(2022, 1, 6),
  new Date(2022, 1, 12),
  new Date(2022, 1, 13),
  new Date(2022, 1, 19),
  new Date(2022, 1, 20),
  new Date(2022, 1, 26),
  new Date(2022, 1, 27),
  //FERIADO
  new Date(2022, 1, 28),
  new Date(2022, 2, 1),


  //Marzo
  new Date(2022, 2, 5),
  new Date(2022, 2, 6),
  new Date(2022, 2, 12),
  new Date(2022, 2, 13),
  new Date(2022, 2, 19),
  new Date(2022, 2, 20),
  new Date(2022, 2, 26),
  new Date(2022, 2, 27),
  //FERIADO
  new Date(2022, 2, 24),

  //Abril
  new Date(2022, 3, 2),
  new Date(2022, 3, 3),
  new Date(2022, 3, 9),
  new Date(2022, 3, 10),
  new Date(2022, 3, 16),
  new Date(2022, 3, 17),
  new Date(2022, 3, 23),
  new Date(2022, 3, 24),
  new Date(2022, 3, 30),
  //FERIADO
  new Date(2022, 3, 15),

  //Mayo
  new Date(2022, 4, 1),
  new Date(2022, 4, 7),
  new Date(2022, 4, 8),
  new Date(2022, 4, 14),
  new Date(2022, 4, 15),
  new Date(2022, 4, 21),
  new Date(2022, 4, 22),
  new Date(2022, 4, 28),
  new Date(2022, 4, 29),
  //FERIADO
  new Date(2022, 4, 25),


  //Junio
  new Date(2022, 5, 4),
  new Date(2022, 5, 5),
  new Date(2022, 5, 11),
  new Date(2022, 5, 12),
  new Date(2022, 5, 18),
  new Date(2022, 5, 19),
  new Date(2022, 5, 25),
  new Date(2022, 5, 26),
  //FERIADO
  new Date(2022, 5, 17),
  new Date(2022, 5, 20),

  //Julio
  new Date(2022, 6, 2),
  new Date(2022, 6, 3),
  new Date(2022, 6, 9),
  new Date(2022, 6, 10),
  new Date(2022, 6, 16),
  new Date(2022, 6, 17),
  new Date(2022, 6, 23),
  new Date(2022, 6, 24),
  new Date(2022, 6, 30),
  new Date(2022, 6, 31),

  //Agosto
  new Date(2022, 7, 6),
  new Date(2022, 7, 7),
  new Date(2022, 7, 13),
  new Date(2022, 7, 14),
  new Date(2022, 7, 20),
  new Date(2022, 7, 21),
  new Date(2022, 7, 27),
  new Date(2022, 7, 28),
  //FERIADO
  new Date(2022, 7, 15),

  //Septiembre
  new Date(2022, 8, 3),
  new Date(2022, 8, 4),
  new Date(2022, 8, 10),
  new Date(2022, 8, 11),
  new Date(2022, 8, 17),
  new Date(2022, 8, 18),
  new Date(2022, 8, 24),
  new Date(2022, 8, 25),

  //Octubre
  new Date(2022, 9, 1),
  new Date(2022, 9, 2),
  new Date(2022, 9, 8),
  new Date(2022, 9, 9),
  new Date(2022, 9, 15),
  new Date(2022, 9, 16),
  new Date(2022, 9, 22),
  new Date(2022, 9, 23),
  new Date(2022, 9, 29),
  new Date(2022, 9, 30),
  //FERIADO
  new Date(2022, 9, 7),
  new Date(2022, 9, 10),

  //Noviembre
  new Date(2022, 10, 5),
  new Date(2022, 10, 6),
  new Date(2022, 10, 12),
  new Date(2022, 10, 13),
  new Date(2022, 10, 19),
  new Date(2022, 10, 20),
  new Date(2022, 10, 26),
  new Date(2022, 10, 27),
  //FERIADO
  new Date(2022, 10, 21),

  // //Diciembre
  new Date(2022, 11, 3),
  new Date(2022, 11, 4),
  new Date(2022, 11, 10),
  new Date(2022, 11, 11),
  new Date(2022, 11, 17),
  new Date(2022, 11, 18),
  new Date(2022, 11, 24),
  new Date(2022, 11, 25),
  new Date(2022, 11, 31),
  //FERIADO
  new Date(2022, 11, 8),
  new Date(2022, 11, 9)
]
